import Checkbox from "common/components/ui/Checkbox";
import {
  DropdownMenuCheckbox,
  DropdownMenuItem,
  dropdownMenuItemVariants,
} from "common/components/ui/DropdownMenu";
import ProfileImage from "common/components/ui/ProfileImage";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";
import type { GenericSearchParam, SearchParamWithImage } from "common/types";

interface SearchParamOptionProps {
  option: GenericSearchParam | SearchParamWithImage;
  isSelected: boolean;
  onSelect: () => void;
  onToggle: () => void;
}

export default function SearchParamOption({
  option,
  isSelected,
  onSelect,
  onToggle,
}: SearchParamOptionProps) {
  const isDesktop = useTwBreakpoint("lg");

  const commonContent =
    "logo_url" in option ? (
      <>
        <ProfileImage src={option.logo_url} size="sm" />
        <div>
          <h5 className="line-clamp-1 break-all text-left text-button-sm">
            {option.name}
          </h5>
          <p className="text-left text-black-400">{option.description}</p>
        </div>
      </>
    ) : (
      <span className="truncate text-left text-button-sm">{option.name}</span>
    );

  if (isDesktop) {
    return (
      <DropdownMenuItem onSelect={onSelect}>
        <DropdownMenuCheckbox
          isChecked={isSelected}
          onCheckedChange={onToggle}
        />
        {commonContent}
      </DropdownMenuItem>
    );
  }
  return (
    <button
      type="button"
      className={dropdownMenuItemVariants()}
      onClick={onToggle}
    >
      <Checkbox checked={isSelected} />
      {commonContent}
    </button>
  );
}
